import { useQuery } from '@apollo/client'
import { dac7BlocksForUser } from './Dac7BlocksForUser.query.gql'

export const useDac7BlocksForUser = () => {
  const { data, loading, error } = useQuery(dac7BlocksForUser)
  return {
    dac7SellingServiceBlock: data?.dac7BlocksForUser.sellingServiceBlock,
    dac7PayoutBlock: data?.dac7BlocksForUser.payoutBlock,
    loading,
    error
  }
}
